<template>
    <div id="app">
        <v-app>
            <Drawer>
                <router-view></router-view>
            </Drawer>
            <Notify/>



        </v-app>
    </div>
</template>

<script>
    import {VApp} from 'vuetify/lib'
    import Drawer from "./components/Drawer";
    import Notify from "./components/Notify";

    export default {


        created() {

        },
        methods: {},
        computed: {},
        name: 'App',
        components: {
            Drawer,
            VApp,
          Notify
        }
    }
</script>
<style lang="scss">

    @import './assets/css/styleAwe.css';
    @import './assets/css/style.css';
    @import './assets/css/custom.scss';

</style>
<style>
    body {
        font-family: "Shabnam FD", Tahoma, Arial, sans-serif !important;
        margin: 0px !important;
        background-color: #f5f5f5;
    }

    .routeProgress {
        z-index: 1000;
        height: 5px;
        width: 100%;
        background-color: #cccccc;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
    }


    .mainApp {
        display: flex;
        align-items: start;

    }

    .routeProgressBar {
        transition: 1s;
        height: 100%;
        background-color: #007aff;
        position: relative;
        left: 0;
    }


    .v-main {
        padding-top: 20px !important;
    }

    #app {
        background-color: #f1f2f5;
        font-family: "Shabnam FD", Tahoma, Arial, sans-serif !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        position: relative;
    }
</style>

<style>
    .slide-leave-active {
        transition: opacity 0.1s ease;
        opacity: 0;
        animation: slide-out 0.1s ease-out forwards;
    }

    .slide-leave {
        opacity: 1;
        transform: translateX(0);
    }

    .slide-enter-active {
        animation: slide-in 0.1s ease-out forwards;
    }

    @keyframes slide-out {
        0% {
            transform: translateY(0);
        }
        100% {
            transform: translateY(-30px);
        }
    }

    @keyframes slide-in {
        0% {
            transform: translateY(-30px);
        }
        100% {
            transform: translateY(0);
        }
    }
</style>
